/* eslint-disable */
import React, { Component } from 'react'

import { View, Text, TouchableOpacity, Image, Dimensions, ImageEditor, ImageStore } from 'react-native'
import styles from './Styles/ImageComponentStyle'
import { getUriNothumb, getUri } from '../Lib/utils'
import { Colors } from '../Themes'
//import FastImage from 'react-native-fast-image'

const { width } = Dimensions.get("window")
const screenWidth = width
const itemWidth = (width) / 4
const itemHeight = itemWidth
export default class ImageComponent extends Component {
  constructor(props) {
    super(props);

    this.imageStyle = {
      width: itemWidth,
      height: itemWidth
    }

  }

 
  checkRatio = (ratio) => {
    const scaleImg =  itemWidth * 1.3
   
    this.imageStyle.width = scaleImg
    this.imageStyle.height = scaleImg
    if (parseFloat(ratio) > 1.0) {
      this.imageStyle.width = scaleImg * parseFloat(ratio)
    } else {
      this.imageStyle.height = scaleImg / parseFloat(ratio)
    }
    
    
    return this.imageStyle
  }
 

  render() {

    const { data, onPress, index, isZoomed, imageStyle = {}, useThumb } = this.props
    const temp = Math.sin(1000 * Math.floor(data.TimeStamp)) * 100000
    const rand = temp - Math.floor(temp)
    const tileIndex = 1 + Math.floor(4 * rand)
    let tileColor
  
    switch (index) {
      case 1:
        tileColor = Colors.cellbg1
        break
      case 2:
        tileColor = Colors.cellbg2
        break
      case 3:
        tileColor = Colors.cellbg3
        break
      default:
        tileColor = Colors.cellbg4
        break
    }

    return (

      <View style={styles.container}>
        <TouchableOpacity style={[styles.content]}
          onPress={onPress}
        >
          {isZoomed && <Image
            source={{
              uri: !useThumb ? getUriNothumb(data.PostId, data.Version) : getUri(data.PostId, data.Version)
            }}
            style={[styles.image,
              {
                backgroundColor: tileColor,
                width: this.checkRatio(data.AspectRatio).width,
                height: this.checkRatio(data.AspectRatio).height
              },
              imageStyle
            ]} />
          }
          {!isZoomed && <Image
            source={{
              uri: (data && !useThumb) ? getUriNothumb(data.PostId, data.Version) : (data && getUri(data.PostId, data.Version))
            }}
            resizeMode="cover"
            style={[styles.image,styles.flex, {backgroundColor: tileColor, overflow: 'hidden'}, imageStyle]} />
          }

        </TouchableOpacity>
      </View>
    )
  }
}
